import { authedFetch } from '../utils/backendFetch.js';

export async function calendarRequest(path, { method = 'GET', body, signal } = {}) {
  // Calendar routes live on the shared appointments/Connect backend, not transcription.
  const base = (process.env.REACT_APP_STRIPE_CONNECT_URL || '').replace(/\/$/, '');
  if (!base) throw new Error('Calendar services are not configured. Please contact your administrator.');
  let response;
  try {
    response = await authedFetch(`${base}/scribe/${path}`, {
      method, signal,
      headers: { 'Content-Type': 'application/json' },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    throw new Error('Unable to reach calendar services. Please try again.');
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const code = data.code || data.error;
    const messages = {
      calendar_not_connected: 'Connect your Google Calendar first.',
      reconnect_required: 'Reconnect your Google Calendar to continue.',
      calendar_reconnect_required: 'Reconnect your Google Calendar to continue.',
      calendar_not_configured: 'Google Calendar is not available yet. Please contact your administrator.',
      calendar_not_enabled: 'Google Calendar is not available yet. Please contact your administrator.',
      therapist_account_required: 'A therapist profile is required to connect your own Google Calendar.',
      google_authorization_failed: 'Google authorization failed. Reconnect your calendar and try again.',
      invalid_oauth_state: 'This connection request expired or belongs to a different session. Please connect again.',
      calendar_permission_required: 'Please allow the requested calendar permissions when connecting.',
      disconnect_before_changing_google_account: 'Disconnect your current Google account before connecting another one.',
      disconnect_to_stop_outbound_sync: 'Disconnect Google Calendar to stop sending appointments.',
      calendar_write_permission_required: 'Choose a Google calendar that you have permission to edit.',
      invalid_calendar_selection: 'The selected calendars are no longer available. Reopen calendar settings.',
      select_one_to_ten_calendars: 'Choose between one and ten calendars for availability.',
      forbidden: 'You do not have permission to manage this calendar.',
      location_not_assigned: 'Add this clinic location to the therapist’s Profile first.',
    };
    const message = messages[code] || (response.status === 409 && path.startsWith('availability')
      ? 'This schedule changed while you were editing. Close and reopen it before saving again.'
      : typeof data.error === 'string' && /[ .]/.test(data.error) ? data.error : 'Unable to update the calendar. Please try again.');
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  return data;
}

export const calendarQuery = values => new URLSearchParams(Object.entries(values).filter(([, value]) => value !== undefined && value !== null && value !== '')).toString();
export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export function validateWeeklyHours(days) {
  for (const day of DAYS) {
    const hours = days[day];
    if (!hours) continue;
    if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(hours.start) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(hours.end) || hours.start >= hours.end) {
      return `Choose a valid start and later end time for ${day}.`;
    }
  }
  return '';
}
